import { render, staticRenderFns } from "./Opponent.vue?vue&type=template&id=2bf09acf&scoped=true&lang=pug&"
import script from "./Opponent.vue?vue&type=script&lang=js&"
export * from "./Opponent.vue?vue&type=script&lang=js&"
import style0 from "./Opponent.vue?vue&type=style&index=0&id=2bf09acf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf09acf",
  null
  
)

export default component.exports